import commonFn from '@/commons/commonFunction';
import BaseAPI from '@/apis/base/baseApi';
import httpClient from '@/apis/base/httpclient';
class VoucherReportPrintAPI extends BaseAPI {
  apiName = 'VoucherReport';
  controllerName = 'VoucherReports';

  /**
   * Lấy danh sách phiếu in theo refType
   */
  getPrintMenu(refType, takeAll = false) {
    let request = { url: [this.getAPIUrl(), '/menu?refType=', refType, '&takeAll=', takeAll].join('') };

    return this.getAsync(request);
  }

  
  /**
   * ldduy 23.1.2023 clone riêng ra 1 hàm async từ hàm getPrintMenu
   */
  async getAsyncPrintMenu(refType, takeAll = false) {
    let request = { url: [this.getAPIUrl(), '/menu?refType=', refType, '&takeAll=', takeAll].join('') };
    return await this.getAsync(request);
  }

  saveReportListSetting(payload) {
    let url = [this.getAPIUrl(), '/menu'].join('');
    return this.postAsync({ url: url, data: payload });
  }
  getReportConfigPrint(refType, reportId) {
    let request = { url: [this.getAPIUrl(), '/ReportConfigPrint?refType=', refType, '&reportId=', reportId].join('') };

    return this.getAsync(request);
  }
  saveReportConfigPrint(payload) {
    let url = [this.getAPIUrl(), '/ReportConfigPrint'].join('');
    return this.postAsync({ url: url, data: payload });
  }
  /**
   * Lưu tham số báo cáo
   * Request này sẽ đẩy tham số lên server và cache lại
   * Sau đó sẽ có 1 request gọi để render ra file pdf và stream về
   * Tình huống việc render chậm sẽ
   * @param {*} data : tham số
   * MODIFIED By NBTIN: Set cache phục vụ PBI in lại mẫu chứng từ gần nhất (PBI 397022)
   */
  saveParamter(param) {
    //xử lý tham số date chuyển thành string bỏ time và múi giờ đi để lên server nhận đúng giá trị
    let fnParam = function (data) {
      if (!data) {
        return;
      }
      commonFn.processDateParam(data, function (value, field) {
        return typeof value.getFullYear === 'function';
      });
    };

    fnParam(param.DataParam);
    fnParam(param.TemplateParam);
    fnParam(param.MisaObject);

    if (param.report_name) {
      param.reportName = param.report_name;
    }
    // Lưu cache lại mẫu chứng từ in lần gần nhất
    try{
      var context = JSON.parse(localStorage?.getItem('mimosa_vuex'))?.context?.Context;
      if(param?.DataParam["$RefType"]){
        var keyPrintMenu = ['printMenu', param?.DataParam["$RefType"], context?.DatabaseId].join('');
        var printMenu = JSON.parse(commonFn.getSessionStorage(keyPrintMenu));
        var report = printMenu.find(x => x.report_id == param.ReportId);
        var keyCache = `previous_print_${context?.DatabaseId}_${context?.UserID}_${param?.DataParam["$RefType"]}`;
        commonFn.setSessionStorage(keyCache,JSON.stringify(report));
      }
    } catch(err){
      console.log(err);
    }
    
    let url = [this.getAPIUrl()].join('');
    return this.postAsync({
      url: url,
      data: param,
    });
  }

  /**
   * Lưu tham số nhiều báo cáo
   * Request này sẽ đẩy tham số lên server và cache lại
   * Sau đó sẽ có 1 request gọi để render ra file pdf và stream về
   * Tình huống việc render chậm sẽ
   * @param {*} data : tham số
   */
  async saveParamterMulti(paramMulti) {
    //xử lý tham số date chuyển thành string bỏ time và múi giờ đi để lên server nhận đúng giá trị
    let fnParam = function (data) {
      if (!data) {
        return;
      }
      commonFn.processDateParam(data, function (value, field) {
        return typeof value.getFullYear === 'function';
      });
    };
    if (paramMulti && Array.isArray(paramMulti)) {
    }
    paramMulti.forEach(param => {
      fnParam(param.DataParam);
      fnParam(param.TemplateParam);
      fnParam(param.MisaObject);
    });

    let url = [this.getAPIUrl(), 'SaveParameterMulti'].join('/');
    return await httpClient.postAsync({
      url: url,
      data: paramMulti,
    });
  }

  /**
   * Lấy link in báo cáo mẫu stimul
   * @param {string} key : key cache tham số
   */
  getPrintLink(key, fileName) {
    return [window._apis.VoucherRender, 'view', key, fileName].join('/');
  }

  /**
   * Lấy link in báo cáo mẫu stimul custom
   * @param {string} key : key cache tham số
   */
  getPrintLinkCustom(key, reportFile, fileName) {
    return [window._apis.VoucherRender, 'view-custom', key, commonFn.removeFileExtension(reportFile), fileName].join('/');
  }

  /**
   * Lấy link down
   * @param {string} key : key cache tham số
   */
  getDownloadink(key, name, ext) {
    return [window._apis.VoucherRender, 'download', key, name, ext].join('/');
  }

  /**
   * Lấy link down
   * @param {string} key : key cache tham số
   */
   getDownloadinkCustom(key, reportFile, name, ext) {
    return [window._apis.VoucherRender, 'download-custom', key, commonFn.removeFileExtension(reportFile), name, ext].join('/');
  }

  /**
   * xuất mẫu báo cáo
   * @param {string} key : key cache tham số
   */
  async exportReportData(key, name, ext) {
    name = name.replaceAll(' ', '_');
    var url = [window._apis.VoucherRender, 'export', key].join('/');

    return await this.getAsync({ url: url, data: { name, ext } });
  }

  /**
   * xuất mẫu báo cáo
   * @param {string} key : key cache tham số
   */
  async exportReportDataMulti(param) {
    var url = window._apis.VoucherRender + `/exportMulti`;

    return await this.postAsync({ url: url, data: param });
  }
  /**
   * Lấy tham số lần in gần nhất
   * @param {*} paramKey reftype hoặc id chứng từ tùy nhu cầu
   * @param {*} refType reftype
   * @param {*} reportId id báo cáo
   * @returns
   * NCPHUOC 19/08/2022
   * Modified by NVTUAN1 24.04.2023: Truyền thêm Id chung của báo cáo có nhiều loại mẫu ngang, dọc, ... để lấy tham số chung cho báo cáo
   */
  async getRecentParam(paramKey, refType, reportId, reportIdCommon) {
    const url = [this.getAPIUrl(), 'PreviouslyParam'].join('/');
    const data = { paramKey, refType, reportId, reportIdCommon };
    const res = await this.getAsync({ url, data });
    return res;
  }

    /**
   * Lấy mẫu stimul
   * @param {*} type 
   * @param {*} fileName 
   * @param {*} databaseId 
   * @returns 
   */
     getDownloadReportLink(type, fileName) {
      return [window._apis.VoucherRender, 'download', type, fileName.replace(/\.[^/.]+$/, "")].join('/');
    }
    /**
     * Cập nhật checkbox "Luôn hiển thị danh sách chứng từ" ở tùy chọn in
     * @param {*} param 
     * @returns 
     * NBTIN 14.12.2023
     */
    async updateStatusDisplayCheckbox(param){
      const url = [this.getAPIUrl(), 'UpdateStatusDisplayCheckbox'].join('/');
      return await this.postAsync({ url: url, data: param });
    }
    /**
     * Lấy trạng thái checkbox "Luôn hiển thị danh sách chứng từ" ở tùy chọn in
     * NBTIN 15.12.2023
     */
    async getStatusDisplayCheckbox(param){
      const url = [this.getAPIUrl(), 'GetStatusDisplayCheckbox'].join('/');
      return await this.postAsync({ url: url, data: param });
    }
    /**
     * Lấy ra mẫu in gần nhất
     * NBTIN 15.12.2023
     */
    async getPreviousReport(param){
      const url = [this.getAPIUrl(), 'GetPreviousReport'].join('/');
      return await this.postAsync({ url: url, data: param });
    }
}

export default new VoucherReportPrintAPI();
